/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 对话状态管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-19 14:54:57
 * @LastEditTime: 2023-11-22 16:33:54
 * @FilePath: /client-h5-v2/src/store/modules/dialog.ts
 */
import {TypeDialogMessage} from '@/type-declare'
import { getCurrentTimeHHMMSS12 } from '@/common-ts/utils'
import store from '@/store/index'

export const dialog = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  dialog/CLEAR_BTN
  state: {
    currentTurnMsgLength: 0,
    // 对话列表（机器人和用户的总列表）
    talklist: [],
    // 机器人对话列表
    botMsgList: [],
    // 用户对话列表
    userMsgList: [],
    // 转人工用户信息(用于发起第一次转人工链接请求'type': 'toAgent','data': 'connect')
    toAgentUserInfo: {},
    // 转人工后的客服信息（魔方）
    engineerInfoMF: {},
    // betterScroll 实例
    bs: null,
    // 用户是否触发了请求动作（用于用户发起请求交互时相关逻辑的触发）
    userRequestActionStatus: false,
    // messageIDmapping {}
    messageIdMapping: {},
    // 消息引用数据
    messageReference: {},
    // 悬浮按钮
    inputTopButtonList: [],
    // 对话接口是否在请求中
    isDialogLoading: false,
    // 对话中timeout信号定时器
    dialogTimeoutTimer: null
  },
  getters: {
    currentTurnMsgLength: (state: any) => state.currentTurnMsgLength,
    talklist: (state: any) => state.talklist,
    botMsgList: (state: any) => state.botMsgList,
    userMsgList: (state: any) => state.userMsgList,
    toAgentUserInfo: (state: any) => state.toAgentUserInfo,
    engineerInfoMF: (state: any) => state.engineerInfoMF,
    bs: (state: any) => state.bs,
    userRequestActionStatus: (state: any) => state.userRequestActionStatus,
    messageIdMapping: (state: any) => state.messageIdMapping,
    messageReference: (state: any) => state.messageReference,
    inputTopButtonList: (state: any) => state.inputTopButtonList,
    isDialogLoading: (state: any) => state.isDialogLoading,
    dialogTimeoutTimer: (state: any) => state.dialogTimeoutTimer
  },
  mutations: {
    CHANGE_USERMESSAGE_STATUS (state: { talklist: TypeDialogMessage[]}, item:any) {
      state.talklist.forEach((value) => {
        if (value.templateType === 'user') {
          if (value.id === item.userMessageId) {
            value.sendMessageStatus = item.status
          }
        }
      })
    },
    SET_TALK_LIST (state: { currentTurnMsgLength: number, talklist: TypeDialogMessage[], toAgentUserInfo: any }, dialogItem:TypeDialogMessage[]) {
      if (!window.location.href.includes('webview')) {
        dialogItem.forEach((value, index) => {
          value['animateDelayIndex'] = index
          if (index === 0) {
            value.avatar = store.getters['signals/agentSuccessStatus'] ? store.getters['global/pageConfig'].botConfig.toAgent.connectingSuccessIcon : store.getters['global/pageConfig'].botConfig.botLogo
            value.currentTimeHHMMSS = getCurrentTimeHHMMSS12()
          } else {
            value.avatar = ''
            value.currentTimeHHMMSS = ''
          }
          if (value.templateType === 'toAgentUserInfo') {
            value.avatar = ''
            const userInfoParams:any = {}
            userInfoParams['type'] = 'toAgentUserInfo'
            userInfoParams['data'] = JSON.parse(value.payload as unknown as string)
            state.toAgentUserInfo = JSON.stringify(userInfoParams)
          }
        })
      }
      console.log(dialogItem)
      state.currentTurnMsgLength = dialogItem.length
      state.talklist.push(...dialogItem)
    },
    CLEAR_TALK_LIST (state: { talklist: TypeDialogMessage[] }) {
      state.talklist = []
    },
    SET_TALK_LIST_HISTORY (state: { talklist: TypeDialogMessage[] }, dialogItem:TypeDialogMessage[]) {
      // 对历史记录中用户一侧的消息进行标记，用于判断是否显示重新发送按钮
      for (const obj of dialogItem) {
        obj.sendMessageStatus = true
      }
      state.talklist.unshift(...dialogItem)
    },
    SET_TALK_LIST_MSG_ID_FOR_MF (state: {talklist: TypeDialogMessage[]}, data:{messageId: string, messageIdMF: string}) {
      // 迭代talklist，将符合条件的消息id替换为messageIdMF
      state.talklist.forEach((value) => {
        if (value.id === data.messageId) {
          value.id = data.messageIdMF
          return
        }
      })
    },
    SET_BOT_MSG_LIST (state: { botMsgList: TypeDialogMessage[] }, dialogItem:TypeDialogMessage[]) {
      state.botMsgList = dialogItem
    },
    SET_USER_MSG_LIST (state: { userMsgList: TypeDialogMessage[] }, userMsgList:TypeDialogMessage[]) {
      state.userMsgList = userMsgList
    },
    CLEAR_BTN (state: { talklist: TypeDialogMessage[] }) {
      state.talklist = state.talklist.filter(item => item.templateType !== 'button')
    },
    CLEAR_LOADING (state: { talklist: TypeDialogMessage[] }) {
      state.talklist = state.talklist.filter(item => item.templateType !== 'loading')
    },
    CLEAR_TALKLIST (state: {talklist: TypeDialogMessage[]}) {
      state.talklist.length = 0
    },
    SET_BS (state: {bs: any}, data:any) {
      state.bs = data
    },
    SET_USER_REQUEST_ACTION_STATUS (state: {userRequestActionStatus: boolean}, data:boolean) {
      state.userRequestActionStatus = data
    },
    SET_ENGINEER_INFO_MF (state: {engineerInfoMF: any}, data:any) {
      state.engineerInfoMF = data
    },
    SET_MESSAGE_REFERENCE (state: {messageReference: any}, data:any) {
      state.messageReference = data
    },
    SET_INPUT_TOP_BUTTON_LIST (state: {inputTopButtonList: any}, data:any) {
      if (data.length) {
        const ButtonList:any = []
        data.map((v:any) => {
          v.payload.map((_v:any) => {
            _v.isHide = true
            ButtonList.push(_v)
          })
        })
        state.inputTopButtonList = ButtonList
      }
    },
    SET_IS_DIALOG_LOADING (state: {isDialogLoading: boolean}, isDialogLoading: boolean) {
      state.isDialogLoading = isDialogLoading
    },
    CLEAR_DIALOG_TIMEOUT_TIMER (state: {dialogTimeoutTimer: any}) {
      clearTimeout(state.dialogTimeoutTimer)
    },
    SET_DIALOG_TIMEOUT_TIMER (state: {dialogTimeoutTimer: any}, data: any) {
      state.dialogTimeoutTimer = data
    }
  },
  actions: {
    // 对话数据提交
    messageFn (store: any, data:TypeDialogMessage|TypeDialogMessage[]):void {
      const wrapData:any = wrapTalkData(data)
      const inputTopButtonList:any = wrapData.filter((i:any) => i.templateType === 'inputTopButton')
      store.commit('SET_TALK_LIST', wrapData)
      store.commit('SET_INPUT_TOP_BUTTON_LIST', inputTopButtonList)
    },
    // 机器人对话数据提交
    botMessageFn (store: any, data:TypeDialogMessage|TypeDialogMessage[]):void {
      store.commit('SET_BOT_MSG_LIST', wrapTalkData(data))
    },
    messageFnHistory (store: any, data:TypeDialogMessage|TypeDialogMessage[]):void {
      const wrapData:any = wrapTalkData(data)
      store.commit('SET_TALK_LIST_HISTORY', wrapData)
    },
    // 用户对话数据提交
    userMessageFn (store: any, data:TypeDialogMessage|TypeDialogMessage[]):void {
      store.commit('SET_USER_MSG_LIST', wrapTalkData(data))
    }
  }
}

// 包装对话数据
function wrapTalkData (data: TypeDialogMessage|TypeDialogMessage[]) {
  // 如果类型是对象，将其包装后提交
  if (Object.prototype.toString.call(data) === '[object Object]') {
    return [data]
  }
  // 如果类型是数组，直接提交
  if (Object.prototype.toString.call(data) === '[object Array]') {
    return data
  }
}
